import type { Currency } from '../stores/meetingStore';
import type { Language } from '../stores/i18nStore';

/**
 * Currency locale mapping
 */
const CURRENCY_LOCALES: Record<Currency, string> = {
  EUR: 'de-DE',
  USD: 'en-US',
  GBP: 'en-GB',
  JPY: 'ja-JP',
  CHF: 'de-CH',
  CAD: 'en-CA',
  AUD: 'en-AU',
};

/**
 * Format currency based on currency code and language
 */
export function formatCurrency(
  amount: number,
  currency: Currency,
  language: Language = 'en'
): string {
  const locale = CURRENCY_LOCALES[currency] || 'en-US';
  
  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: currency,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(amount);
}

/**
 * Format time as HH:MM:SS
 */
export function formatTime(seconds: number): string {
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const secs = seconds % 60;
  
  return [hours, minutes, secs]
    .map((val) => String(val).padStart(2, '0'))
    .join(':');
}

/**
 * Format number with locale-aware formatting
 */
export function formatNumber(value: number, language: Language = 'en'): string {
  const locale = language === 'de' ? 'de-DE' : 
                 language === 'fr' ? 'fr-FR' :
                 language === 'ja' ? 'ja-JP' :
                 language === 'es' ? 'es-ES' : 'en-US';
  
  return new Intl.NumberFormat(locale).format(value);
}
